var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"transition-generic w-full wrapper-lg"},[_vm._v(" ... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }